import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import ProfileCard from '../components';

const mapStateToProps = state => ({
  lang: state.i18n.language,
});

export default withRouter(connect(mapStateToProps)(ProfileCard));
